import React from 'react';
import { ElasticBlogResult } from "@scripts/frontend/types/elastic-blog-result";
import PlayOnHover from "@scripts/frontend/insights/components/PlayOnHover";
interface Props {
  baseUrl: string;
  post: ElasticBlogResult;
}
const InsightsCard: React.FC<Props> = ({ post, baseUrl }) => {
  const { title, slug, featured_image, featured_video, content_type, logo } = post;
  const [isHovered, setIsHovered] = React.useState(false);
  const isNews = content_type.raw === 'News';
  const cardClassName = `a-insights-card${isNews ? ' a-news-card' : ''}`;
  return (
    <a
      href={`${baseUrl}${slug.raw}`}
      className={cardClassName}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="a-insights-card__inner">
        {/* NEWS layout */}
        {isNews ? (
          <>
            {logo?.raw && (
              <img
                src={logo.raw}
                alt=""
                role="presentation"
                className="a-news-card__logo"
                loading="lazy"
                decoding="async"
              />
            )}
            <h2 className="a-insights-card__title">{title.raw ?? ''}</h2>
            <div className="a-insights-card__tags">
              <div className="a-insights-card__tag">{content_type.raw}</div>
            </div>
          </>
        ) : (
          /* DEFAULT (INSIGHT) layout */
          <>
            <div className={featured_video.raw ? 'a-insights-card__media-container has-video' : 'a-insights-card__media-container'}>
              <img
                src={featured_image.raw ?? ''}
                alt=""
                role="presentation"
                className="a-insights-card__image"
                loading="lazy"
                decoding="async"
              />
              {featured_video.raw && (
                <PlayOnHover
                  loop
                  play={isHovered}
                  videoSrc={featured_video.raw ?? ''}
                  className="a-insights-card__video"
                />
              )}
            </div>
            <h2 className="a-insights-card__title">{title.raw ?? ''}</h2>
            {content_type.raw && (
              <div className="a-insights-card__pill-wrapper">
                <div className="a-pill a-pill--gray">
                  <div className="a-pill__middle">
                    <span className="a-pill__label">{content_type.raw}</span>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </a>
  );
};
export default InsightsCard;
